<template>
	<div class="menubar-global is-hidden" :style="{ display: 'flex' }" style='border: 2px solid red; border-radius: 20px; margin-bottom: 20px'>

		<template v-for="(item, index) in items">
			<div class="divider" v-if="item.type === 'divider'" :key="index" />
			<menu-item
				@varpop="
					() => {
						$emit('varpop')
					}
				"
				v-else
				:key="index"
				v-bind="item"
			/>
		</template>
	</div>
</template>
<script>
import MenuItem from "./MenuItem.vue"
import InputModal from "@/modules/_common/modal/input-modal"

export default {
	components: {
		MenuItem,
		InputModal
	},
	props: {

	},
	data() {
		return {
			showURLModal: false,
			urlvalue: undefined,
			items: [
				{
					icon: "bold",
					title: this.$t("bold"),
					action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().toggleBold().run()}}),

					isVisible: () => true
				},
				{
					icon: "italic",
					title: this.$t("italic"),
					action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().toggleItalic().run()}}),


					isVisible: () => true
				},
				{
					icon: "strikethrough",
					title: this.$t("strikethrough"),

					action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().toggleStrike().run()}}),
					isVisible: () => true
				},
				{
					icon: "underline",
					title: this.$t("underline"),

					action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().toggleUnderline().run()}}),
					isVisible: () => true
				},
				{
					icon: "mark-pen-line",
					title: this.$t("highlight"),
					action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().toggleHighlight().run()}}),
					isVisible: () => true
				},
				{
					type: "divider",
					isVisible: () => true
				},
				{
					icon: "h-1",
					title: this.$t("h1"),

					action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().toggleHeading({ level: 1 }).run()}}),
					isVisible: () => true
				},
				{
					icon: "h-2",
					title: this.$t("h2"),

					action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().toggleHeading({ level: 2 }).run()}}),
					isVisible: () => true
				},
				{
					icon: "h-3",
					title: this.$t("h3"),

					action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().toggleHeading({ level: 3 }).run()}}),
					isVisible: () => true
				},

				{
					icon: "font-size-2",
					title: this.$t("size"),

					action: size => this.$emit("callback", {fct: function(editor){editor.chain().focus().setSize(size).run()}}),
					isVisible: () => true,
					is_procedural: true,
					dropdown: true
				},

				{
					icon: "font-size",
					title: this.$t("text-type"),
					isVisible: () => true,
					dropdown: [
						{
							title: "Default",

							action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().unsetFontFamily().run()}}),

						},
						{
							title: "Comic Sans",

							action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setFontFamily("Comic Sans MS, Comic Sans").run()}}),
						},
						{
							title: "Serif",

							action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setFontFamily("serif").run()}}),
						},
						{
							title: "Monospace",

							action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setFontFamily("monospace").run()}}),
						},
						{
							title: "Cursive",

							action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setFontFamily("cursive").run()}}),
						}
					]
				},

				{
					icon: "font-color",
					title: this.$t("text-color"),
					isVisible: () => true,
					subelements: [
						{
							icon: "font-color",
							title: this.$t("black"),

							action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setColor("#000000").run()}}),
							isVisible: () => true
						},
						{
							icon: "font-color",
							title: this.$t("red"),
							color: "#F44336",


							action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setColor("rgb(255,0,0)").run()}}),
							isVisible: () => true
						},
						{
							icon: "font-color",
							title: this.$t("blue"),
							color: "#2196F3",

							action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setColor("#2196F3").run()}}),
							isVisible: () => true
						},
						{
							icon: "font-color",
							title: this.$t("green"),
							color: "#8BC34A",


							action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setColor("#8BC34A").run()}}),
							isVisible: () => true
						},
						{
							icon: "font-color",
							title: this.$t("gray"),
							color: "#9E9E9E",

							action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setColor("#9E9E9E").run()}}),
							isVisible: () => true
						},
						{
							icon: "font-color",
							title: this.$t("brown"),
							color: "#795548",

							action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setColor("#795548").run()}}),

							isVisible: () => true
						},
						{
							icon: "font-color",
							title: this.$t("yellow"),
							color: "#FFEE58",

							action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setColor("#FFEE58").run()}}),
							isVisible: () => true
						},
						{
							icon: "font-color",
							title: this.$t("purple"),
							color: "#9575CD",

							action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setColor("#9575CD").run()}}),

							isVisible: () => true
						}
					]
				},

				{
					type: "divider",
					isVisible: () => true
				},
				{
					icon: "align-justify",
					title: this.$t("align"),
					isVisible: () => true,
					subelements: [
						{
							icon: "align-left",
							title: this.$t("align-left"),

							action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setTextAlign("left").run()}}),
							isVisible: () => true
						},
						{
							icon: "align-center",
							title: this.$t("align-center"),

							action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setTextAlign("center").run()}}),
							isVisible: () => true
						},
						{
							icon: "align-right",
							title: this.$t("align-right"),
							action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setTextAlign("right").run()}}),
							isVisible: () => true
						},
						{
							icon: "align-justify",
							title: this.$t("justify"),

							action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setTextAlign("justify").run()}}),

							isVisible: () => true
						}
					]
				},
				{
					icon: "paragraph",
					title: this.$t("paragraph"),
					action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setParagraph().run()}}),

					isVisible: () => true
				},
				{
					icon: "list-unordered",
					title: this.$t("list-unordered"),
					action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().toggleBulletList().run()}}),

					isVisible: () => true
				},
				{
					icon: "list-ordered",
					title: this.$t("list-ordered"),
					action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().toggleOrderedList().run()}}),

					isVisible: () => true
				},
				{
					icon: "list-check-2",
					title: this.$t("task-list"),
					action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().toggleTaskList().run()}}),

					isVisible: () => true
				},
				{
					icon: "double-quotes-l",
					title: this.$t("quote"),
					action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().toggleBlockquote().run()}}),

					isVisible: () => true
				},
				{
					type: "divider",
					isVisible: () => true
				},
				{
					icon: "text-wrap",
					title: this.$t("hard-break"),
					action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().setHardBreak().run()}}),

					isVisible: () => true
				},
				{
					icon: "format-clear",
					title: this.$t("clear-format"),
					action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().unsetAllMarks().run()}}),

					isVisible: () => true
				},
				{
					type: "divider",
					isVisible: () => true
				},
				{
					icon: "arrow-go-back-line",
					title: this.$t("cancel"),
					action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().undo().run()}}),

					isVisible: () => true
				},
				{
					icon: "arrow-go-forward-line",
					title: this.$t("redo"),
					action: () => this.$emit("callback", {fct: function(editor){editor.chain().focus().redo().run()}}),

					isVisible: () => true
				},
				{
					type: "divider",
					isVisible: () => true
				},

			]
		}
	},
	methods: {
		showVarModal(command) {
			this.$refs.videoModal.showModal(command)
		},

	}
}
</script>
<style lang="scss" scoped>
.divider {
	width: 2px;
	height: 1.25rem;
	background-color: rgba(0, 0, 0, 0.1);
	margin-left: 0.5rem;
	margin-right: 0.75rem;
}
</style>
